import e from "./index32.js";
//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/compose/compose.js
function t(...t) {
	let n = t.reduce((e, t) => (t.filterProps.forEach((n) => {
		e[n] = t;
	}), e), {}), r = (t) => Object.keys(t).reduce((r, i) => n[i] ? e(r, n[i](t)) : r, {});
	return r.propTypes = process.env.NODE_ENV === "production" ? {} : t.reduce((e, t) => Object.assign(e, t.propTypes), {}), r.filterProps = t.reduce((e, t) => e.concat(t.filterProps), []), r;
}
//#endregion
export { t as default };

//# sourceMappingURL=index39.js.map